// theme.js
export const blueTheme = {
  body: "#EDF9FE",
  text: "#001C55",
  highlight: "#A6E1FA",
  dark: "#00072D",
  secondaryText: "#7F8DAA",
  imageHighlight: "#0E6BA8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#0A2472",
  headerColor: "#0E6BA877",
};

export const purpleTheme = {
  body: "#F8EFF4",
  text: "#000000",
  highlight: "#E0B1CB",
  dark: "#00072D",
  secondaryText: "#655E7A",
  imageHighlight: "#BE95C4",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#5E548E",
  headerColor: "#BE95C477",
};

export const blackTheme = {
  body: "#E5E5E5",
  text: "#14213d",
  highlight: "#ffffff",
  dark: "#000000",
  secondaryText: "#5A6377",
  imageHighlight: "#fca311",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8d99ae",
  headerColor: "#fca31177",
};

export const violetTheme = {
  body: "#FFFFFF",
  text: "#302F42",
  highlight: "#D0CDE1",
  dark: "#21052C",
  secondaryText: "#403E57",
  imageHighlight: "#6D64FF",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#313043",
  headerColor: "#6D64FF",
};

export const chosenTheme = violetTheme;
